export default __webpack_public_path__ + "static/media/history_museum_london_landscape.4ef0b50b.jpg";